export default __webpack_public_path__ + "static/media/dfl-4-rMIN.ec98ce8a.avif";